export function TextLogo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center font-bold text-2xl ${className}`}>
      <span className="text-gray-800">boosted</span>
      <span className="text-red-600">pins</span>
    </div>
  );
}

export function Logo({ className = "" }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background with gradient */}
      <rect width="40" height="40" rx="8" fill="url(#gradient)" />
      
      {/* Modern Pin Design */}
      <path
        d="M20 8c-6.07 0-11 4.93-11 11 0 4.78 3.8 8.79 8.89 10.52.04-1.1.15-2.8.37-4.01.41-1.76 2.67-11.16 2.67-11.16s-.67-1.33-.67-3.31c0-3.08 1.79-5.39 4.02-5.39 1.89 0 2.81 1.42 2.81 3.12 0 1.9-1.21 4.74-1.83 7.37-.52 2.21 1.11 4.02 3.29 4.02 3.95 0 6.61-5.07 6.61-11.09C35.16 13.72 31.83 8 24.91 8c-5.43 0-9.49 3.88-9.49 8.23 0 1.5.44 2.54 1.13 3.36.32.38.36.53.25.97-.08.31-.28 1.05-.36 1.34-.12.45-.48.61-.89.45C12.82 21.68 11.5 19.07 11.5 16c0-5.63 4.77-12.38 14.24-12.38 7.61 0 12.61 5.5 12.61 11.41 0 7.82-4.35 13.67-10.76 13.67-2.15 0-4.17-1.16-4.86-2.49 0 0-1.15 4.56-1.4 5.44-.42 1.53-1.25 3.07-2.01 4.26.19.06.38.09.58.09h.1C25.94 36 31 30.94 31 24.5S25.94 13 20 13"
        fill="white"
      />
      
      {/* Boost Arrow */}
      <path
        d="M28 18l4 4-4 4"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Gradient Definition */}
      <defs>
        <linearGradient id="gradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E60023" />
          <stop offset="1" stopColor="#BD081C" />
        </linearGradient>
      </defs>
    </svg>
  );
} 